const RETRIEVE_REPORT = "RETRIEVE_REPORT";
const RECIEVE_REPORT = "RECIEVE_REPORT";

export default {
	RETRIEVE_REPORT,
	RECIEVE_REPORT
}